/* @ngInject */
function HomeCampaignsFinishingSoonController ($scope, $state, $rootScope, CampaignService, SegmentService, $translate, $sce) {
  $scope.flags = {
    hasCampaignFinishingSoon: false,
    closeCampaignsFinishingSoonInfoCard: false
  }
  $scope.campaigns = []
  $scope.campaignFinishingSoonText = ''
  $scope.campaignFinishingSoonButtonText = ''

  const api = {
    _getCampaignsFinishingSoon,
    _getCampaignFinishingSoonText,
    _getCampaignFinishingSoonButtonText
  }
  this.getApi = () => api

  activate()

  function activate () {
    api._getCampaignsFinishingSoon()
  }

  $scope.closeCampaignsFinishingSoonInfoCard = () => {
    $scope.flags.closeCampaignsFinishingSoonInfoCard = true
  }

  $scope.navigateToCampaignsFinishingSoon = () => {
    if ($scope.campaigns.length > 1) {
      $state.go('campaigns')
    } else {
      $state.go('campaigns-edit', { id: $scope.campaigns[0].id })
    }
  }

  async function _getCampaignsFinishingSoon () {
    const user = await $rootScope.getUser()
    if (!$rootScope.isUserSysAdminAdmin(user)) return

    const campaignsFinishingSoon = await CampaignService.getCampaignsFinishingSoon()
    $scope.flags.hasCampaignFinishingSoon = campaignsFinishingSoon?.length > 0
    $scope.campaigns = campaignsFinishingSoon
    $scope.campaignFinishingSoonText = api._getCampaignFinishingSoonText()
    $scope.campaignFinishingSoonButtonText = api._getCampaignFinishingSoonButtonText()
  }

  function _getCampaignFinishingSoonText () {
    if ($scope.campaigns.length > 1) {
      return $sce.trustAsHtml($translate.instant('campaignsFinishingSoon.plural', { count: $scope.campaigns.length }))
    }
    const campaignName = `<strong>${$scope.campaigns[0].title}</strong>`
    return $sce.trustAsHtml(`${$translate.instant('campaignsFinishingSoon.singular.firstText', { days: $scope.campaigns[0].days })} ${campaignName} ${$translate.instant('campaignsFinishingSoon.singular.secondText')}`)
  }

  function _getCampaignFinishingSoonButtonText () {
    if ($scope.campaigns.length > 1) {
      return $translate.instant('campaignsFinishingSoon.buttons.plural')
    }
    return $translate.instant('campaignsFinishingSoon.buttons.singular')
  }
}

export { HomeCampaignsFinishingSoonController }
